export default __webpack_public_path__ + "static/media/water_5.aac653b6.png";